query getTopics {
  topics: getTopics {
    id
    name
    description
    status
    isSystemGenerated
    isUserEditable
    links
    createdAt
    updatedAt
    visibility {
      contentCreator
      topics
      acquisitionBooster
      materialUploads
    }
    landingpage {
      id
      slug
    }
  }
}
